import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import * as OriginalSupplyActions from "./actions";
import type { IOriginalSupplyState } from "./types";

const initialState: IOriginalSupplyState = {
  machines: [],
  hasError: false,
  isFetching: false
};

export default function originalSupplyReducer(
  state: IOriginalSupplyState = initialState,
  action: ActionType<typeof OriginalSupplyActions>
): IOriginalSupplyState {
  switch (action.type) {
    case getType(OriginalSupplyActions.fetchMachinesStart): {
      return {
        ...state,
        isFetching: true
      };
    }

    case getType(OriginalSupplyActions.fetchMachinesFail): {
      return {
        ...state,
        hasError: true,
        isFetching: false
      };
    }

    case getType(OriginalSupplyActions.fetchMachinesSuccess): {
      return {
        ...state,
        machines: action.payload,
        isFetching: false
      };
    }

    default:
      return state;
  }
}
